var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    locale: "[object Object]",
    className: "svgIcon appStoreGoogle",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 180 53.3",
    style: {
      fill: "rgb(32, 32, 38)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.33333 0 0 -1.33333 0 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M1299.8 200H49.7c-27.5 0-50 22.5-50 50v300c0 27.5 22.5 50 50 50h1250c27.5 0 50-22.5 50-50V250c.1-27.5-22.4-50-49.9-50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M1299.8 600H49.7c-27.5 0-50-22.5-50-50V250c0-27.5 22.5-50 50-50h1250c27.5 0 50 22.5 50 50v300c.1 27.5-22.4 50-49.9 50m0-8c23.2 0 42-18.8 42-42V250c0-23.2-18.8-42-42-42H49.7c-23.2 0-42 18.8-42 42v300c0 23.2 18.8 42 42 42h1250.1",
    fill: "#36373A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#fff",
    d: "M474 497.6c0-8.4-2.5-15-7.5-20-5.6-5.9-13-8.9-22-8.9-8.7 0-16 3-22.1 9s-9.1 13.4-9.1 22.3 3 16.3 9.1 22.3 13.4 9 22.1 9c4.3 0 8.4-.8 12.3-2.5 3.9-1.7 7-3.9 9.4-6.7l-5.3-5.3c-4 4.7-9.4 7.1-16.4 7.1-6.3 0-11.8-2.2-16.4-6.7-4.6-4.4-6.9-10.2-6.9-17.3s2.3-12.9 6.9-17.3c4.6-4.4 10.1-6.7 16.4-6.7 6.7 0 12.3 2.2 16.8 6.7 2.9 2.9 4.6 7 5 12.2h-21.8v7.2h29.1c.2-1.5.4-3 .4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fill: "#fff",
    d: "M474 497.6h-1c0-8.2-2.4-14.5-7.2-19.3-5.5-5.7-12.5-8.6-21.3-8.6-8.4 0-15.5 2.9-21.4 8.7-5.9 5.8-8.8 13-8.8 21.6 0 8.7 2.9 15.8 8.8 21.6 5.9 5.8 12.9 8.7 21.4 8.7 4.2 0 8.1-.8 11.9-2.4 3.8-1.6 6.8-3.8 9-6.4l.8.6-.7.7-5.3-5.3.7-.7.8.6c-4.2 5-10 7.5-17.2 7.5-6.5 0-12.3-2.3-17.1-6.9-4.8-4.6-7.2-10.7-7.2-18s2.4-13.4 7.2-18 10.5-7 17.1-6.9c6.9 0 12.8 2.3 17.5 7 3.1 3.1 4.9 7.4 5.3 12.8l.1 1.1h-21.9v5.2h28.1v1l-1-.2c.3-1.5.4-3 .4-4.4h2c0 1.5-.1 3.1-.4 4.7l-.1.8h-30.9v-9.2h22.8v1l-1 .1c-.4-5-2-8.8-4.7-11.5-4.3-4.3-9.6-6.4-16.1-6.4-6.1 0-11.2 2.1-15.7 6.4-4.4 4.3-6.6 9.7-6.6 16.6s2.2 12.3 6.6 16.6c4.4 4.3 9.6 6.4 15.7 6.4 6.8 0 11.9-2.2 15.7-6.8l.7-.8 6 6.1.6.6-.6.7c-2.5 2.9-5.7 5.3-9.8 7-4 1.7-8.3 2.6-12.7 2.6-8.9 0-16.6-3.1-22.8-9.3-6.2-6.2-9.4-13.9-9.4-23s3.1-16.9 9.4-23c6.2-6.2 13.9-9.3 22.8-9.3 9.3 0 16.9 3.1 22.8 9.2l-.7.7.7-.7c5.2 5.2 7.8 12.2 7.7 20.7l-1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#fff",
    d: "M520.1 522.6h-27.3v-19h24.6v-7.2h-24.6v-19h27.3V470h-35v60h35v-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    fill: "#fff",
    d: "M520.1 522.6v1h-28.3v-21h24.6v-5.2h-24.6v-21h27.3V471h-33v58h33v-6.4h1v1-1h1v8.4h-37v-62h37v9.4h-27.3v17h24.6v9.2h-24.6v17h27.3v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "#fff",
    d: "M552.6 470h-7.7v52.6h-16.8v7.4h41.2v-7.4h-16.8l.1-52.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    fill: "#fff",
    d: "M552.6 470v1h-6.7v52.6h-16.8v5.4h39.2v-5.4h-16.8V470h1.1v1-1h1v51.6h16.8v9.4h-43.2v-9.4H544V469h9.7v1h-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#fff",
    d: "M599.2 470v60h7.7v-60h-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    fill: "#fff",
    d: "M599.2 470h1v59h5.7v-58h-6.7v-1h1-1v-1h8.7v62h-9.7v-62h1v1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#fff",
    d: "M641.1 470h-7.7v52.6h-16.8v7.4h41.2v-7.4H641l.1-52.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    fill: "#fff",
    d: "M641.1 470v1h-6.7v52.6h-16.8v5.4h39.2v-5.4H640V470h1.1v1-1h1v51.6h16.7v9.4h-43.2v-9.4h16.8V469h9.7v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    fill: "#fff",
    d: "M697.6 482.8c4.4-4.5 9.9-6.7 16.3-6.7s11.9 2.2 16.3 6.7 6.7 10.2 6.7 17.2-2.2 12.7-6.7 17.2c-4.4 4.5-9.9 6.7-16.3 6.7s-11.9-2.2-16.3-6.7-6.7-10.2-6.7-17.2 2.3-12.7 6.7-17.2zm38.3-5c-5.9-6.1-13.2-9.1-22-9.1s-16.1 3-22 9.1-8.8 13.5-8.8 22.2 2.9 16.2 8.8 22.2c5.9 6.1 13.2 9.1 22 9.1 8.7 0 16-3 22-9.1 5.9-6.1 8.9-13.5 8.9-22.2-.1-8.8-3-16.2-8.9-22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    fill: "#fff",
    d: "M697.6 482.8l-.7-.7c4.6-4.7 10.4-7.1 17-7 6.7 0 12.4 2.4 17 7 4.6 4.7 7 10.7 7 17.9 0 7.2-2.3 13.2-7 17.9-4.6 4.7-10.4 7.1-17 7-6.7 0-12.4-2.4-17-7-4.6-4.7-7-10.7-6.9-17.9 0-7.2 2.3-13.2 6.9-17.9l.7.7.7.7c-4.2 4.3-6.4 9.7-6.4 16.5s2.1 12.2 6.4 16.5c4.3 4.3 9.4 6.4 15.6 6.4 6.2 0 11.3-2.1 15.6-6.4 4.2-4.3 6.4-9.7 6.4-16.5s-2.1-12.2-6.4-16.5c-4.3-4.3-9.4-6.4-15.6-6.4-6.2 0-11.3 2.1-15.6 6.4l-.7-.7zm38.3-5l-.7.7c-5.7-5.9-12.7-8.8-21.3-8.8-8.5 0-15.6 2.9-21.3 8.8-5.7 5.9-8.5 13-8.6 21.6 0 8.5 2.8 15.7 8.6 21.6 5.7 5.9 12.7 8.8 21.3 8.8 8.5 0 15.5-2.9 21.2-8.8 5.7-5.9 8.6-13 8.6-21.5s-2.8-15.7-8.6-21.6l.8-.8.7-.7c6.1 6.2 9.1 13.9 9.1 22.9 0 8.9-3.1 16.6-9.2 22.9-6.1 6.3-13.7 9.5-22.7 9.4-9 0-16.7-3.1-22.7-9.4-6.1-6.2-9.1-14-9.1-22.9 0-9 3-16.7 9.1-22.9 6.1-6.3 13.7-9.4 22.7-9.4s16.7 3.1 22.7 9.4l-.6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    fill: "#fff",
    d: "M755.6 470v60h9.4l29.2-46.7h.3l-.3 11.6V530h7.7v-60h-8l-30.5 48.9h-.3l.3-11.6V470h-7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    fill: "#fff",
    d: "M755.6 470h1v59h7.8l29.2-46.7h1.9l-.4 12.6V529h5.7v-58h-6.5l-30.5 48.9h-1.9l.4-12.6V471h-6.7v-1h1-1v-1h8.7v38.4L764 519h-1v-1h.3v1l-.8-.5 30.8-49.4h9.6v62h-9.7V495l.3-11.6h1v1h-.3v-1l.8.5-29.5 47.1h-10.9v-62h1v1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    fill: "#fff",
    d: "M1069.2 300h18.7v125h-18.7V300zm168 80l-21.4-54.2h-.6L1193 380h-20.1l33.3-75.8-19-42.1h19.5L1258 380h-20.8zm-105.8-65.8c-6.1 0-14.6 3.1-14.6 10.6 0 9.6 10.6 13.3 19.8 13.3 8.2 0 12.1-1.8 17.1-4.2-1.5-11.5-11.5-19.7-22.3-19.7zm2.3 68.5c-13.5 0-27.5-6-33.3-19.1l16.6-6.9c3.5 6.9 10.1 9.2 17.1 9.2 9.7 0 19.5-5.8 19.6-16.1v-1.3c-3.4 1.9-10.6 4.8-19.5 4.8-17.8 0-36-9.8-36-28.1 0-16.7 14.6-27.5 31-27.5 12.6 0 19.5 5.6 23.8 12.2h.6v-9.6h18v47.9c0 22.1-16.5 34.5-37.9 34.5zm-115.4-17.9h-26.5v42.9h26.5c13.9 0 21.9-11.5 21.9-21.4 0-9.8-7.9-21.5-21.9-21.5zm-.4 60.2h-44.7V300h18.6v47.4h26.1c20.7 0 41 15 41 38.8 0 23.8-20.4 38.8-41 38.8zM774.1 314.2c-12.9 0-23.7 10.8-23.7 25.6 0 15 10.8 25.9 23.7 25.9 12.7 0 22.7-11 22.7-25.9 0-14.8-10-25.6-22.7-25.6zm21.4 58.8h-.7c-4.2 5-12.2 9.5-22.4 9.5-21.3 0-40.8-18.7-40.8-42.7 0-23.8 19.5-42.4 40.8-42.4 10.1 0 18.2 4.5 22.4 9.7h.6V301c0-16.3-8.7-25-22.7-25-11.4 0-18.5 8.2-21.4 15.1l-16.3-6.8c4.7-11.3 17.1-25.1 37.7-25.1 21.9 0 40.4 12.9 40.4 44.3v76.4h-17.7V373h.1zm30.6-73h18.7v125h-18.7V300zm46.2 41.2c-.5 16.4 12.7 24.8 22.2 24.8 7.4 0 13.7-3.7 15.8-9l-38-15.8zm58 14.2c-3.5 9.5-14.3 27.1-36.4 27.1-21.9 0-40.1-17.2-40.1-42.5 0-23.8 18-42.5 42.2-42.5 19.5 0 30.8 11.9 35.4 18.8l-14.5 9.7c-4.8-7.1-11.4-11.8-20.9-11.8s-16.3 4.4-20.6 12.9l56.9 23.5-2 4.8zm-453.1 14v-18h43.2c-1.3-10.1-4.7-17.6-9.8-22.7-6.3-6.3-16.1-13.2-33.3-13.2-26.6 0-47.4 21.4-47.4 48s20.8 48 47.4 48c14.3 0 24.8-5.6 32.5-12.9l12.7 12.7c-10.8 10.3-25.1 18.2-45.3 18.2-36.4 0-67-29.6-67-66.1 0-36.4 30.6-66.1 67-66.1 19.7 0 34.5 6.4 46.1 18.5 11.9 11.9 15.6 28.7 15.6 42.2 0 4.2-.3 8.1-1 11.3l-60.7.1zM588 314.2c-12.9 0-24 10.6-24 25.8 0 15.3 11.1 25.8 24 25.8s24-10.5 24-25.8c0-15.2-11.1-25.8-24-25.8zm0 68.3c-23.5 0-42.7-17.9-42.7-42.5 0-24.5 19.2-42.5 42.7-42.5s42.7 18 42.7 42.5c0 24.6-19.2 42.5-42.7 42.5zm93.2-68.3c-12.9 0-24 10.6-24 25.8 0 15.3 11.1 25.8 24 25.8s24-10.5 24-25.8c0-15.2-11.2-25.8-24-25.8zm0 68.3c-23.5 0-42.7-17.9-42.7-42.5 0-24.5 19.2-42.5 42.7-42.5 23.5 0 42.7 18 42.7 42.5 0 24.6-19.2 42.5-42.7 42.5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M104.8 276.1l-.7.7c-2.9 3.1-4.6 7.9-4.6 14.1v-1.5 221.2-1.5c0 6.7 2 11.8 5.4 14.8L228.8 400l-124-123.9m-5.4 234.5v0m.1 1.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path72_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18811.891,
    y1: -21267.199,
    x2: -18810.891,
    y2: -21267.199,
    gradientTransform: "scale(-4.2194) rotate(45 -34956.32 11951.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M104.8 276.1l-.7.7c-2.9 3.1-4.6 7.9-4.6 14.1v-1.5 221.2-1.5c0 6.7 2 11.8 5.4 14.8L228.8 400l-124-123.9m-5.4 234.5v0m.1 1.7",
    fill: "url(#path72_1_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M270 357.2l.9.5 48.9 27.8c4.7 2.7 7.8 5.9 9.3 9.3-1.5-3.4-4.7-6.6-9.3-9.3l-48.9-27.8-.9-.5m0 1.5L228.8 400l41.3 41.3L320 413c6.3-3.6 9.9-8.2 10.5-13-.6-4.7-4.1-9.4-10.5-13l-50-28.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path92_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -20002.412,
    y1: -21661.736,
    x2: -20001.412,
    y2: -21661.736,
    gradientTransform: "rotate(180 -42853.031 -46391.445) scale(4.3017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M270 357.2l.9.5 48.9 27.8c4.7 2.7 7.8 5.9 9.3 9.3-1.5-3.4-4.7-6.6-9.3-9.3l-48.9-27.8-.9-.5m0 1.5L228.8 400l41.3 41.3L320 413c6.3-3.6 9.9-8.2 10.5-13-.6-4.7-4.1-9.4-10.5-13l-50-28.3",
    fill: "url(#path92_1_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M113.6 271.4c-3.5 0-6.5 1.1-8.8 3.2 2.4-2.1 5.4-3.2 8.8-3.2h.9-.9m0 1.5c-3.5 0-6.5 1.1-8.8 3.2l124 123.9 41.3-41.3-145.2-82.5c-4.1-2.3-7.9-3.3-11.3-3.3m-8.8 1.8l-.6.6.6-.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g96",
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path108_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18853.475,
    y1: -21699.688,
    x2: -18852.475,
    y2: -21699.688,
    gradientTransform: "scale(-5.7218) rotate(45 -35562.742 11823.155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M113.6 271.4c-3.5 0-6.5 1.1-8.8 3.2 2.4-2.1 5.4-3.2 8.8-3.2h.9-.9m0 1.5c-3.5 0-6.5 1.1-8.8 3.2l124 123.9 41.3-41.3-145.2-82.5c-4.1-2.3-7.9-3.3-11.3-3.3m-8.8 1.8l-.6.6.6-.6",
    fill: "url(#path108_1_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g110"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M228.8 400l-124 123.9c2.4 2.1 5.4 3.2 8.8 3.2 3.4 0 7.2-1.1 11.2-3.4L270 441.2 228.8 400m42.2 42.2l-146.1 83c-4 2.3-7.8 3.4-11.2 3.4h.1c3.4 0 7.2-1.1 11.2-3.4l146-83m-157.5 86.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g112",
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path130_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -16251.162,
    y1: -23175.293,
    x2: -16250.162,
    y2: -23175.293,
    gradientTransform: "scale(2.555) rotate(-45 20145.964 -31121.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "M228.8 400l-124 123.9c2.4 2.1 5.4 3.2 8.8 3.2 3.4 0 7.2-1.1 11.2-3.4L270 441.2 228.8 400m42.2 42.2l-146.1 83c-4 2.3-7.8 3.4-11.2 3.4h.1c3.4 0 7.2-1.1 11.2-3.4l146-83m-157.5 86.4",
    fill: "url(#path130_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M114.6 271.4c3.1.2 6.6 1.3 10.3 3.3L270 357.2l-145.1-82.5c-3.7-2-7.2-3.1-10.3-3.3m-9.8 3.2c0 .1 0 0 0 0m-.7.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g134"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M270 357.2l1 .6-1-.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g136",
    clipPath: "url(#SVGID_10_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path152_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -20002.412,
    y1: -21652.018,
    x2: -20001.412,
    y2: -21652.018,
    gradientTransform: "rotate(180 -42853.031 -46391.445) scale(4.3017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#cc9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#cc8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7d00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M270 357.2l.9.5-.9-.5",
    fill: "url(#path152_1_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g154"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M113.6 271.4c-3.5 0-6.5 1.1-8.8 3.3l-.6.6-.1.1.7.7c2.4-2.1 5.4-3.3 8.8-3.2 3.4 0 7.2 1.1 11.2 3.4L270 358.8l.9-.9-.9-.5-145.1-82.5c-3.7-2.1-7.1-3.2-10.3-3.3-.4-.2-.7-.2-1-.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g156",
    clipPath: "url(#SVGID_12_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path168_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18853.475,
    y1: -21699.582,
    x2: -18852.475,
    y2: -21699.582,
    gradientTransform: "scale(-5.7218) rotate(45 -35562.742 11823.155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc2e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c0e4e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M113.6 271.4c-3.5 0-6.5 1.1-8.8 3.3l-.6.6-.1.1.7.7c2.4-2.1 5.4-3.3 8.8-3.2 3.4 0 7.2 1.1 11.2 3.4L270 358.8l.9-.9-.9-.5-145.1-82.5c-3.7-2.1-7.1-3.2-10.3-3.3-.4-.2-.7-.2-1-.2",
    fill: "url(#path168_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M104.1 275.4c-2.9 3.1-4.6 7.9-4.6 14.1-.1-6.3 1.6-11.1 4.6-14.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g172"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M104.1 275.4c-2.9 3.1-4.6 7.9-4.6 14.1v1.5c0-6.2 1.7-11 4.6-14.1l.7-.7-.7-.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g174",
    clipPath: "url(#SVGID_14_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path194_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18811.891,
    y1: -21248.135,
    x2: -18810.891,
    y2: -21248.135,
    gradientTransform: "scale(-4.2194) rotate(45 -34956.32 11951.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#008de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00a7e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c7e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M104.1 275.4c-2.9 3.1-4.6 7.9-4.6 14.1v1.5c0-6.2 1.7-11 4.6-14.1l.7-.7-.7-.8",
    fill: "url(#path194_1_)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g196"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M104.1 275.4l.7.7-.7-.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g198",
    clipPath: "url(#SVGID_16_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path210_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18853.475,
    y1: -21704.791,
    x2: -18852.475,
    y2: -21704.791,
    gradientTransform: "scale(-5.7218) rotate(45 -35562.742 11823.155)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0333c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ab0f56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M104.1 275.4l.7.7-.7-.7",
    fill: "url(#path210_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M329.3 394.8c.8 1.7 1.2 3.4 1.2 5.2-.1-1.8-.5-3.5-1.2-5.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g214"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M271 357.8l-.9.9L320 387c6.3 3.6 9.9 8.2 10.5 13 0-1.7-.4-3.5-1.2-5.2-1.6-3.4-4.7-6.6-9.3-9.3l-49-27.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    clipPath: "url(#SVGID_18_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path232_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -20002.412,
    y1: -21657.006,
    x2: -20001.412,
    y2: -21657.006,
    gradientTransform: "rotate(180 -42853.031 -46391.445) scale(4.3017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0c500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#e0a600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#e09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e08900"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M271 357.8l-.9.9L320 387c6.3 3.6 9.9 8.2 10.5 13 0-1.7-.4-3.5-1.2-5.2-1.6-3.4-4.7-6.6-9.3-9.3l-49-27.7",
    fill: "url(#path232_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    fill: "#404040",
    d: "M330.4 400c0 5.2-3.5 10.5-10.5 14.4L271 442.2l48.9-27.8c7-3.9 10.5-9.2 10.5-14.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g236"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M330.4 400c-.6 4.7-4.1 9.4-10.5 13L270 441.3l.9.9 48.9-27.8c7.1-3.9 10.6-9.2 10.6-14.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g238",
    clipPath: "url(#SVGID_20_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path254_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -20002.412,
    y1: -21666.815,
    x2: -20001.412,
    y2: -21666.815,
    gradientTransform: "rotate(180 -42853.031 -46391.445) scale(4.3017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffce40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#ffbc40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb540"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M330.4 400c-.6 4.7-4.1 9.4-10.5 13L270 441.3l.9.9 48.9-27.8c7.1-3.9 10.6-9.2 10.6-14.4",
    fill: "url(#path254_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    fill: "#404040",
    d: "M99.5 512.2c0 .1 0 .1 0 0 0 .1 0 .1 0 0m0 .2c.6 10.3 6.2 16.2 14.1 16.2-3.4 0-6.4-1.1-8.7-3.2l-.7-.7c-2.8-2.9-4.4-7-4.7-12.3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g258"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M99.4 509.1v3.2c.3 5.3 2 9.5 4.6 12.3l.7-.7c-3.3-3-5.3-8.1-5.3-14.8m5.4 16.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g260",
    clipPath: "url(#SVGID_22_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path280_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -18811.891,
    y1: -21287.307,
    x2: -18810.891,
    y2: -21287.307,
    gradientTransform: "scale(-4.2194) rotate(45 -34956.32 11951.093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40b8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#40b9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#40ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#40ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#40e7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40eaff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M99.4 509.1v3.2c.3 5.3 2 9.5 4.6 12.3l.7-.7c-3.3-3-5.3-8.1-5.3-14.8m5.4 16.2",
    fill: "url(#path280_1_)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    fill: "#404040",
    d: "M113.5 528.6s.1 0 0 0c.1 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g284"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M270 441.3l-145.1 82.5c-4 2.3-7.8 3.4-11.2 3.4-3.5 0-6.5-1.1-8.8-3.2l-.7.7.7.7c2.3 2.1 5.3 3.2 8.7 3.2 3.4 0 7.2-1.1 11.2-3.4l146.1-83-.9-.9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g286",
    clipPath: "url(#SVGID_24_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path304_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -16251.162,
    y1: -23175.266,
    x2: -16250.162,
    y2: -23175.266,
    gradientTransform: "scale(2.555) rotate(-45 20145.964 -31121.24)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65b895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#62bd95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#50db97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#44ed98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40f498"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M270 441.3l-145.1 82.5c-4 2.3-7.8 3.4-11.2 3.4-3.5 0-6.5-1.1-8.8-3.2l-.7.7.7.7c2.3 2.1 5.3 3.2 8.7 3.2 3.4 0 7.2-1.1 11.2-3.4l146.1-83-.9-.9",
    fill: "url(#path304_1_)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.d2b10f3fee691e30c7794715283a9a69.svg";
export { ForwardRef as ReactComponent };